// PO-GST-01 · P2-UAT-D01-FIX01 · Supplier GST registration type (UI only; backend owns validation + audit).
export const GST_REG_TYPES = ["REGULAR", "UNREGISTERED", "COMPOSITION", "SEZ", "IMPORT", "UNVERIFIED"];
export const REASON_MIN = 4;
export const SUPPLIER_CLASS_FINDING = "SUPPLIER_CLASSIFICATION_UNVERIFIED";
export const SUPPLIER_CLASS_GUIDANCE =
  "Confirm Supplier Master → GST Registration Type, then re-save this Draft PO to refresh its GST snapshot.";

// Missing / unknown stored value is shown as UNVERIFIED — never inferred from GSTIN or state.
export const displayRegType = (s) => {
  const v = String(s?.gst_registration_type || "").trim().toUpperCase();
  return GST_REG_TYPES.includes(v) ? v : "UNVERIFIED";
};

export const canClassifySupplierGst = (user, hasPermFn) =>
  user?.role === "Administrator" && !!hasPermFn?.("masters_suppliers:edit");

export const reasonValid = (r) => (r || "").trim().length >= REASON_MIN;

export async function classifySupplierGst(api, supplierId, type, reason) {
  const { data } = await api.put(`/suppliers/${supplierId}/gst-classification`,
    { gst_registration_type: type, reason: (reason || "").trim() });
  return data;
}
